import { Controller } from "stimulus";
import { createPopper } from "@popperjs/core";

export default class extends Controller {
  static targets = ["content"];

  connect() {
    this.scrollHandler = () => this.hide();
  }

  show() {
    this.contentTarget.style.display = "";
    this.popper = createPopper(this.element, this.contentTarget, {
      placement: "top",
      strategy: "fixed",
      modifiers: [
        { name: "preventOverflow", options: { padding: this.overflowPadding() } },
        {
          name: "flip",
          options: {
            fallbackPlacements: ["bottom", "right", "left"],
            padding: this.overflowPadding(),
          },
        },
        { name: "offset", options: { offset: [0, 4] } },
      ],
    });
    window.addEventListener("scroll", this.scrollHandler, { capture: true, passive: true });
  }

  hide() {
    this.contentTarget.style.display = "none";
    window.removeEventListener("scroll", this.scrollHandler, { capture: true });
    this.popper?.destroy();
    this.popper = null;
  }

  overflowPadding() {
    const header = document.querySelector("header.sticky");
    const top = header ? header.getBoundingClientRect().height + 4 : 8;

    return { top, right: 8, bottom: 8, left: 8 };
  }
}
